<template>
    <v-col
        cols="12"
        sm="12"
        md="6"
        lg="3"
        class="pa-0"
        tile
    >
        <v-card
            light
            outlined
            tile
            color="#fff"
        >
            <v-card-title class="w-100">
                <span class="text-h6 font-weight-light">Pools Cleaned by Cleaners</span>
                <v-spacer></v-spacer>
                <div class="text-end pa-2">
                    <v-select
                        v-model="filter.range"
                        :items="items"
                        label="Date Range"
                        dense
                        width="100"
                        hide-details
                        @change="getData"
                    ></v-select>
                </div>
            </v-card-title>

            <v-card-text>
                <Pie
                    v-if="loaded"
                    :chart-options="chartOptions"
                    :chart-data="chartData"
                    :chart-id="chartId"
                    :dataset-id-key="datasetIdKey"
                    :plugins="plugins"
                    :css-classes="cssClasses"
                    :styles="styles"
                    :width="width"
                    :height="height"
                />
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import axios from 'axios'
import { Pie } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
    name: 'PieChart',
    components: {
        Pie
    },
    props: {
        chartId: {
        type: String,
        default: 'pie-chart'
        },
        datasetIdKey: {
        type: String,
        default: 'label'
        },
        width: {
        type: Number,
        default: 400
        },
        height: {
        type: Number,
        default: 400
        },
        cssClasses: {
        default: '',
        type: String
        },
        styles: {
        type: Object,
        default: () => {}
        },
        plugins: {
        type: Array,
        default: () => []
        }
    },
    data() {
        return {
            loaded: false,
            items: ['7 Days', '30 Days', '6 Months', '12 Months'],
            filter: {
                range: '30 Days',
            },
            chartData: null,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData() {
            this.loaded = false

            try {
                await axios.get('crm/cleaning/chart', {
                    params: this.filter
                })
                .then(response => {
                    this.loaded = true
                    this.chartData = response.data
                    this.$nextTick()
                })
            } catch (e) {
                console.error(e)
            }
        },
    }
}
</script>
